import React from "react";
import PropTypes from "prop-types";
import "./Badge.scss";

export const BADGE_VARIANTS = [
  "success",
  "error",
  "info",
  "warning",
  "primary",
];

const Badge = ({ variant, children, className }) => {
  const classes = ["ht-badge", `ht-badge--${variant}`, className]
    .filter(Boolean)
    .join(" ");
  return <span className={classes}>{children}</span>;
};

Badge.propTypes = {
  variant: PropTypes.oneOf(BADGE_VARIANTS).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Badge;
